import type { RecordView } from '@kit/sync/types/record-view';
import { useRecords } from '@/entities/shared/record/use-records';
import type { ShoppingItem } from '../schemas/shopping-item';

export function useShoppingItems(): RecordView<ShoppingItem>[] | undefined {
  return useRecords<ShoppingItem>('shopping');
}
